import http from '@http';

class SvietimasService {
    constructor() {
        if (SvietimasService.instance) {
            return SvietimasService.instance;
        }

        SvietimasService.instance = this;
    }

    getClasses(kindergartenId, options) {
        return http.get(`/api/kindergartens/${kindergartenId}/svietimas/courses`, {params: options}).then(res => res.data);
    }

    getChildren(kindergartenId, options) {
        return http.get(`/api/kindergartens/${kindergartenId}/svietimas/children`, {params: options})
            .then(res => res.data);
    }

    importData(kindergartenId, data) {
        return http.post(`/api/kindergartens/${kindergartenId}/svietimas/import`, data).then(res => res.data);
    }

    getStatus(kindergartenId) {
        return http.get(`/api/kindergartens/${kindergartenId}/svietimas/status`).then(res => res.data);
    }
}
export default new SvietimasService();
